import React, { PureComponent } from 'react';
import Button from './Button';

class ButtonOutline extends PureComponent {
    state = {};

    render() {
        let { classes = [], ...props } = this.props;
        return <Button {...props} classes={['fm-button__outline', ...classes]} />;
    }
}

export default ButtonOutline;
